/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeActions from "../../models/store/storeActions";
import * as storeEffects from "../../models/store/storeEffects";
import { UserFurtherEducationEditView, IUserFurtherEducationEditOwnProps, IUserFurtherEducationEditDispatchProps, IUserFurtherEducationEditStateProps } from "../../components/userFurtherEducation/userFurtherEducationEdit";
import { Base } from "ui/Scripts/source/framework/base";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IUserFurtherEducationEditOwnProps): IUserFurtherEducationEditStateProps {
    if (Base.isNullOrUndefined(applicationState) || Base.isNullOrUndefined(applicationState.task) || Base.isNullOrUndefined(applicationState.task.taskEdit)) {
        return {
            item: null,
            attachments: [],
            furtherEducationGroups: [],
            qualifications: [],
            returnUrl: ""
        };
    }
    const list = applicationState.userFurtherEducation.userFurtherEducationList;
    const edit = applicationState.userFurtherEducation.userFurtherEducationEdit;
    return {
        item: edit.item,
        attachments: edit.attachments,
        furtherEducationGroups: edit.furtherEducationGroups,
        qualifications: list.qualifications,
        returnUrl: edit.returnUrl
    };
}

export function mapDispatchToProps(dispatch: storeEffects.UserFurtherEducationThunkDispatch): IUserFurtherEducationEditDispatchProps {
    return {
        loadUserFurtherEducation: (id: string) => dispatch(storeEffects.getUserFurtherEducationEdit(id)),
        resetUserFurtherEducation: () => dispatch(storeActions.userFurtherEducationEditReset())
    };
}

export default withRouter(connect<IUserFurtherEducationEditStateProps, IUserFurtherEducationEditDispatchProps, IUserFurtherEducationEditOwnProps>(mapStateToProps, mapDispatchToProps)(UserFurtherEducationEditView));